// extracted by mini-css-extract-plugin
export default {"root":"DoubleSelect_root__wtAFa","select1":"DoubleSelect_select1__i4-Eu","select2":"DoubleSelect_select2__fQEbs","select1Error":"DoubleSelect_select1Error__eduZ8"};